import Proptypes from 'prop-types';

export const vehicleProptypes = Proptypes.shape({
    maxBidAWStatus: Proptypes.number,
    updatedAWSAmounts: Proptypes.bool,
    UserAmountBidMaxAWS: Proptypes.oneOfType([
        Proptypes.number,
        Proptypes.string,
    ]),
    AmountAWS: Proptypes.oneOfType([Proptypes.number, Proptypes.string]),
    Brand: Proptypes.string,
    CV: Proptypes.number,
    Co2: Proptypes.oneOfType([Proptypes.number, Proptypes.string]),
    DifferentialAmount: Proptypes.number,
    Energy: Proptypes.string,
    EntryQuota: Proptypes.number,
    FeeRvo: Proptypes.number,
    HasBidModality: Proptypes.bool,
    HasDirectPurchaseModality: Proptypes.bool,
    HasOpenLotModality: Proptypes.bool,
    HasRentingModality: Proptypes.bool,
    HasTransportAvailable: Proptypes.bool,
    Id: Proptypes.number,
    ImageSource: Proptypes.string,
    IsBlocked: Proptypes.bool,
    IsFavorite: Proptypes.bool,
    KmQuota: Proptypes.number,
    Kms: Proptypes.number,
    LocationId: Proptypes.string,
    MinimumPrice: Proptypes.number,
    Model: Proptypes.string,
    ModelLong: Proptypes.string,
    MonthsQuota: Proptypes.number,
    OriginDescription: Proptypes.string,
    OriginId: Proptypes.number,
    Plate: Proptypes.string,
    Price: Proptypes.number,
    Province: Proptypes.string,
    PublicationDate: Proptypes.string,
    PublicationEndDate: Proptypes.string,
    RegistrationDate: Proptypes.string,
    Status: Proptypes.number,
    Tmaimg: Proptypes.string,
    Transmission: Proptypes.string,
    VIN: Proptypes.string,
    WebSalesId: Proptypes.number,
});
